import React from 'react';
import './PulseButton.scss';

const PulseButton = ({ children, ...otherProps }) => (
  <button className={'pulse_button'} {...otherProps}>
    {children}
  </button>
);
export default PulseButton;
